/**
 * Log a failed *silent* Realtime catch-up re-fetch at the right severity.
 *
 * Every list store, on a watched change, fires a silent re-fetch (see
 * {@link createRealtimeSync}). When connectivity drops, the socket flaps AND
 * those catch-up fetches fail together. A transient network failure is a
 * breadcrumb; a NON-network failure (RLS 403, malformed query, 5xx) keeps its
 * warning. The triage itself is {@link logReadFailure}, shared by every reader.
 */
import { logReadFailure } from '../net/logReadFailure';

type LogContext = Readonly<Record<string, unknown>>;

/**
 * @param label  Human label for the failed resync, e.g. `'newsletter campaigns resync failed'`.
 * @param err    The caught error (Supabase PostgrestError, fetch TypeError, …).
 * @param context Extra tags to attach (e.g. `{ id }`); `message` is added automatically.
 */
export function logResyncFailure(label: string, err: unknown, context?: LogContext): void {
  logReadFailure('realtime', label, err, context);
}
